import React from 'react';
import PropTypes from 'prop-types';
import ProcessingModeWrapper from './ProcessingModeWrapper';
import CitedByWrapper from './CitedByWrapper';
import PatentTitle from './PatentTitle';

function PatentTitleMainFamilyMember({ title }) {
  return (
    <CitedByWrapper>
      <ProcessingModeWrapper>
        <PatentTitle title={title} tag="h3" className="patent-content__title--main-family-member" />
      </ProcessingModeWrapper>
    </CitedByWrapper>
  );
}

PatentTitleMainFamilyMember.propTypes = {
  title: PropTypes.string,
};

export default PatentTitleMainFamilyMember;
